module.exports = __webpack_public_path__ + "img/skyx.40c59b60.png";